module.exports = __webpack_public_path__ + "static/media/intro-windows.48c87acc.png";